let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("16JGn")).then(() => parcelRequire('hQAUR'));